import { render, staticRenderFns } from "./entities-geojson-data-source.vue?vue&type=template&id=9b5230ce&scoped=true"
import script from "./entities-geojson-data-source.vue?vue&type=script&lang=js"
export * from "./entities-geojson-data-source.vue?vue&type=script&lang=js"
import style0 from "./entities-geojson-data-source.vue?vue&type=style&index=0&id=9b5230ce&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5230ce",
  null
  
)

export default component.exports